export default process.env.ALCHEMY_URL ||
  'https://eth-mainnet.alchemyapi.io/v2/Zdn1C5wpuQp8N8ESdHIqSxSHQaZHGsY2';
